<template>
    <div>
        <v-mu-picker ref="picker" :code="value.AccountCode" v-on:pick="onPickMuhasebe"/>
        <div class="row">
            <div class="col-12 mb-1">
                <label class="form-label">Kasa</label>
                <v-select-list  v-model="kasa" :disabled="editing" :options="kasaList" label="KSMAS_NAME" placeholder="Kasa" :loading="kasaLoading"></v-select-list>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Muhasebe Kodu</label>
                <div class="d-flex g-50">
                    <input class="form-control" v-model="value.AccountCode" readonly disabled placeholder="Muhasebe Kodu"/>
                    <button class="btn btn-outline-primary text-nowrap" v-on:click="$refs.picker.pick()">Hesap Seç</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NetsisOperationsApi from '@/api/netsis-operations'
import VMuPicker from '@/components/VMuPicker.vue';

export default{
    components:{
        VMuPicker
    },
    props:{
        value:Object,
        editing:Boolean
    },
    data(){
        return {
            kasaLoading:false,
            kasaList:[],
        }
    },
    mounted(){
        this.getKasaList()
    },
    methods:{
        onPickMuhasebe(e){
            this.value.AccountCode = e?.MuhasebeKodu || null
        },
        getKasaList(){
            this.kasaLoading = true
            NetsisOperationsApi.GetKasaList().then(res => {
                this.kasaList = res.data.Data
                this.kasaLoading = false
            }).catch(err=> {
                console.log(err)
                this.kasaLoading = false
            })
        },
    },
    computed:{
        kasa:{
            get:function(){
                return this.kasaList.find(s=>s.KSMAS_KOD==this.value.VaultCode)
            },
            set:function(value){
                this.value.VaultCode = value?.KSMAS_KOD || null
                this.value.VaultName = value?.KSMAS_NAME || null
            }
        },
    }
}
</script>